export const VALIDATE_PASSWORD = "sub-users/VALIDATE_PASSWORD";

export default function validatePasswordAction() {
  return {
    "payload": {},
    "type": VALIDATE_PASSWORD
  };
}
